/**
 * Skeleton — Loading placeholder primitive
 *
 * A simple animated pulse block used to indicate loading state.
 * Size and shape are controlled entirely via `className`.
 *
 * @example
 * ```tsx
 * // Text line placeholder
 * <Skeleton className="h-4 w-48" />
 *
 * // Circular avatar placeholder
 * <Skeleton className="h-10 w-10 rounded-full" />
 *
 * // Toggle/pill placeholder
 * <Skeleton className="h-6 w-11 rounded-full" />
 * ```
 */

import type { HTMLAttributes } from 'react'
import { cn } from '#utils'

export type SkeletonProps = HTMLAttributes<HTMLDivElement>

export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-surface-3', className)}
      {...props}
    />
  )
}
